import React from 'react';
import { cx } from '@emotion/css';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { BodyLargeEmphasized } from '../Typography';
import styles from './NavBar.styles';
import { AccessibleDivButton } from '@/components';
import { useGoogleTranslator } from '@/hooks';

interface Props {
  children: React.ReactNode;
  onClickCloseButton?: () => void;
  buttonPosition: 'left' | 'right';
  id?: string;
}

export const NavBarCloseButton: React.FC<Props> = ({
  children,
  onClickCloseButton,
  buttonPosition = 'left',
  id,
}) => {
  const titleTranslated = useGoogleTranslator(children as string);
  return (
  <header className={styles.container} data-testid="navbar">
    <AccessibleDivButton
      className={cx(
        styles.icon,
        buttonPosition === 'left'
          ? styles.closeButtonLeft
          : styles.closeButtonRight,
      )}
      onClick={onClickCloseButton}
    >
      <CloseOutlinedIcon />
    </AccessibleDivButton>
    <BodyLargeEmphasized data-testid="pageName" className={styles.title} as='h1' id={id}>
      {titleTranslated}
    </BodyLargeEmphasized>
  </header>
);
}
